<template>
  <section id="calculator" class="section full-height">
    <div class="container full-width box" style="transition: all 0.5s linear" v-show="!printing">
      <div class="columns full-height">
        <div class="column is-narrow is-hidden-touch spaced-column">
          <aside class="menu">
            <div style="padding: 1rem;">
              <img src="../../../static/FBE.png" height="128" width="128">
            </div>
            <transition name="fade" mode="out-in">
            <ul class="menu-list">
              <li v-if="data.propertyDetails.villageName && state !== 'start' && state !== 'assumptions' && state !== 'property-details' && state != 'review'">
                <b-tag type="is-primary" size="is-medium">{{data.propertyDetails.villageName + " - " + data.propertyDetails.unitNumber}}</b-tag>
                <hr/>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'start'}" v-on:click="jumpStart" :disabled="cleanRun === false">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.start !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.start === 'valid'">
                  </b-icon>
                  <span>Start</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'assumptions'}" v-on:click="jumpAssumptions" :disabled="status.assumptions === 'pristine' || cleanRun === false">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.assumptions !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.assumptions === 'valid'">
                  </b-icon>
                  <span>Assumptions</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'basic-information'}" v-on:click="jumpBasicInformation" :disabled="status.basicInformation === 'pristine' || cleanRun === false">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.basicInformation !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.basicInformation === 'valid'">
                  </b-icon>
                  <span>About You</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'property-details'}" v-on:click="jumpPropertyDetails" :disabled="status.propertyDetails === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.propertyDetails !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.propertyDetails === 'valid'">
                  </b-icon>
                  <span>Property Details</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'ingoing-fees'}" v-on:click="jumpIngoingFees" :disabled="status.ingoingFees === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.ingoingFees !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.ingoingFees === 'valid'">
                  </b-icon>
                  <span>Ingoing Fees</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'ongoing-fees'}" v-on:click="jumpOngoingFees" :disabled="status.ongoingFees === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.ongoingFees !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.ongoingFees === 'valid'">
                  </b-icon>
                  <span>Ongoing Fees</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'capital-gain-loss'}" v-on:click="jumpCapitalGainLoss" :disabled="status.capitalGainLoss === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.capitalGainLoss !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.capitalGainLoss === 'valid'">
                  </b-icon>
                  <span>Capital Gain/Loss</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'outgoing-fees'}" v-on:click="jumpOutgoingFees" :disabled="status.outgoingFees === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.outgoingFees !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.outgoingFees === 'valid'">
                  </b-icon>
                  <span>Outgoing Fees</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'additional-outgoing-fees'}" v-on:click="jumpAdditionalOutgoingFees" :disabled="status.additionalOutgoingFees === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.additionalOutgoingFees !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.additionalOutgoingFees === 'valid'">
                  </b-icon>
                  <span>Additional Outgoing Fees</span>
                </a>
              </li>
              <li>
                <a class="button class-transition is-fullwidth menu-button" v-bind:class="{'is-primary' : state === 'resultA'}" v-on:click="jumpResult" :disabled="status.resultA === 'pristine'">
                  <b-icon
                    pack="far"
                    icon="circle" v-if="status.resultA !== 'valid'">
                  </b-icon>
                  <b-icon
                    pack="fas"
                    icon="check" v-show="status.resultA === 'valid'">
                  </b-icon>
                  <span>Result</span>
                </a>
              </li>
            </ul>
            </transition>
          </aside>
        </div>
        <div class="column spaced-column">
          <mq-layout mq="mobile">
            <img class="center-logo" src="../../../static/MQ_MAS_HOR_RGB_POS.png" height="256" width="256">
          </mq-layout>
          <transition name="fade" mode="out-in">
            <start v-if="state === 'start'" v-model="agree"/>
            <assumptions v-if="state === 'assumptions'" v-model="data.assumptions"/>
            <basic-information v-if="state === 'basic-information'" v-model="data.basicInformation"/>
            <property-details v-if="state === 'property-details'" v-model="data.propertyDetails"/>
            <ingoing-fees v-if="state === 'ingoing-fees'" v-model="data.ingoingFees"/>
            <ongoing-fees v-if="state === 'ongoing-fees'" v-model="data.ongoingFees"/>
            <capital-gain-loss v-if="state === 'capital-gain-loss'" v-model="data.capitalGainLoss"/>
            <outgoing-fees v-if="state === 'outgoing-fees'" v-model="data.outgoingFees"/>
            <additional-outgoing-fees v-if="state === 'additional-outgoing-fees'" v-model="data.additionalOutgoingFees"/>
            <result-a v-if="state === 'resultA'" :value="responsePayload" v-bind:loading="loading"/>
            <result-b v-if="state === 'resultB'" :value="responsePayload"/>
            <review v-if="state === 'review'" :value="printData"/>
          </transition>

          <nav class="level is-mobile nav-buttons">
            <div class="level-left">
              <div class="level-item">
                <button class="button is-primary" v-if="state !== 'start' !== (cleanRun === false && state === 'property-details')" v-on:click="previous">
                  <b-icon pack="fas" icon="arrow-left"></b-icon>
                  <span>Previous</span>
                </button>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <button class="button is-primary" v-on:click="printResults" v-if="state === 'review'">
                  <span>Print</span>
                </button>
              </div>
              <div class="level-item">
                <button class="button is-primary" v-on:click="restartCalculator" v-if="state === 'review'">
                  <span>Restart the Calculator</span>
                </button>
              </div>
              <div class="level-item">
                <button class="button is-primary" disabled v-if="!agree">
                  <span>Next</span>
                  <b-icon pack="fas" icon="arrow-right"></b-icon>
                </button>
                <button class="button is-primary" v-on:click="next" v-if="state !== 'review' && agree">
                  <span>Next</span>
                  <b-icon pack="fas" icon="arrow-right"></b-icon>
                </button>
                <button class="button is-primary" v-on:click="enterAnotherContract" v-if="state === 'review'">
                  <span>Enter another contract</span>
                  <b-icon pack="fas" icon="undo"></b-icon>
                </button>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>

    <div v-if="printing">
      <table class="table" style="font-size: 10px;">
        <thead>
          <tr>
            <th></th>
            <th><label class="label">{{printData.list[0].data.propertyDetails.unitNumber + " - " + printData.list[0].data.propertyDetails.villageName}}</label></th>
            <template v-if="printData.length > 1">
              <th><label class="label">{{printData.list[1].data.propertyDetails.unitNumber + " - " + printData.list[1].data.propertyDetails.villageName}}</label></th>
            </template>
            <template v-if="printData.length > 2">
              <th><label class="label">{{printData.list[2].data.propertyDetails.unitNumber + " - " + printData.list[2].data.propertyDetails.villageName}}</label></th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th><label class="label">Results - Equivalent monthly rent</label></th>
            <th></th>
            <template v-if="printData.length > 1">
              <th></th>
            </template>
            <template v-if="printData.length > 2">
              <th></th>
            </template>
          </tr>
          <tr>
            <th>average term of residence ({{responsePayload.response.expected_healthy_lifespan}} years)</th>
            <th>{{responsePayload.response.expected_healthy_lifespan_year_rent_per_month | currency}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].response.expected_healthy_lifespan_year_rent_per_month | currency}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].response.expected_healthy_lifespan_year_rent_per_month | currency}}</th>
            </template>
          </tr>
          <tr>
            <th>2 year term</th>
            <th>{{responsePayload.response.two_year_rent_per_month | currency}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].response.two_year_rent_per_month | currency}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].response.two_year_rent_per_month | currency}}</th>
            </template>
          </tr>
          <tr>
            <th>5 year term</th>
            <th>{{responsePayload.response.five_year_rent_per_month | currency}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].response.five_year_rent_per_month | currency}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].response.five_year_rent_per_month | currency}}</th>
            </template>
          </tr>
          <tr>
            <th>10 year term</th>
            <th>{{responsePayload.response.ten_year_rent_per_month | currency}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].response.ten_year_rent_per_month | currency}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].response.ten_year_rent_per_month | currency}}</th>
            </template>
          </tr>
          <tr>
            <th>20 year term</th>
            <th>{{responsePayload.response.twenty_year_rent_per_month | currency}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].response.twenty_year_rent_per_month | currency}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].response.twenty_year_rent_per_month | currency}}</th>
            </template>
          </tr>
          <!-- your information -->
          <tr>
            <th><label class="label">Your Information</label></th>
            <th></th>
            <template v-if="printData.length > 1">
              <th></th>
            </template>
            <template v-if="printData.length > 2">
              <th></th>
            </template>
          </tr>
          <tr>
            <th>single / couple</th>
            <!-- 1 -->
            <th v-if="data.basicInformation.isCouple">Couple</th>
            <th v-if="!data.basicInformation.isCouple">Single</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="printData.list[1].data.basicInformation.isCouple">Couple</th>
              <th v-if="!printData.list[1].data.basicInformation.isCouple">Single</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="printData.list[2].data.basicInformation.isCouple">Couple</th>
              <th v-if="!printData.list[2].data.basicInformation.isCouple">Single</th>
            </template>
          </tr>
          <tr>
            <th>age</th>
            <!-- 1 -->
            <th>{{data.basicInformation.age}}</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.basicInformation.age}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.basicInformation.age}}</th>
            </template>
          </tr>
          <tr>
            <th>gender</th>
            <!-- 1 -->
            <th v-if="data.basicInformation.gender === 'Male'">Male</th>
            <th v-if="data.basicInformation.gender === 'Female'">Female</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="printData.list[1].data.basicInformation.gender === 'Male'">Male</th>
              <th v-if="printData.list[1].data.basicInformation.gender === 'Female'">Female</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="printData.list[2].data.basicInformation.gender === 'Male'">Male</th>
              <th v-if="printData.list[2].data.basicInformation.gender === 'Female'">Female</th>
            </template>
          </tr>
          <tr>
            <th>partner's age</th>
            <!-- 1 -->
            <th v-if="data.basicInformation.isCouple">{{data.basicInformation.partnerAge}}</th>
            <th v-if="!data.basicInformation.isCouple">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="printData.list[1].data.basicInformation.isCouple">{{data.basicInformation.partnerAge}}</th>
              <th v-if="!printData.list[1].data.basicInformation.isCouple">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="printData.list[2].data.basicInformation.isCouple">{{data.basicInformation.partnerAge}}</th>
              <th v-if="!printData.list[2].data.basicInformation.isCouple">n / a</th>
            </template>
          </tr>
          <tr>
            <th>partner's gender</th>
            <!-- 1 -->
            <th v-if="(data.basicInformation.isCouple) && (data.basicInformation.partnerGender === 'Male')">Male</th>
            <th v-if="(data.basicInformation.isCouple) && (data.basicInformation.partnerGender === 'Female')">Female</th>
            <th v-if="!data.basicInformation.isCouple">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.basicInformation.isCouple) && (printData.list[1].data.basicInformation.partnerGender === 'Male')">Male</th>
              <th v-if="(printData.list[1].data.basicInformation.isCouple) && (printData.list[1].data.basicInformation.partnerGender === 'Female')">Female</th>
              <th v-if="!printData.list[1].data.basicInformation.isCouple">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.basicInformation.isCouple) && (printData.list[2].data.basicInformation.partnerGender === 'Male')">Male</th>
              <th v-if="(printData.list[2].data.basicInformation.isCouple) && (printData.list[2].data.basicInformation.partnerGender === 'Female')">Female</th>
              <th v-if="!printData.list[2].data.basicInformation.isCouple">n / a</th>
            </template>
          </tr>
          <!-- fee information -->
          <tr>
            <th><label class="label">Fee Information</label></th>
            <th></th>
            <template v-if="printData.length > 1">
              <th></th>
            </template>
            <template v-if="printData.length > 2">
              <th></th>
            </template>
          </tr>
          <tr>
            <th>ingoing fee</th>
            <!-- 1 -->
            <th>${{data.ingoingFees.ingoingFee}}</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th>${{printData.list[1].data.ingoingFees.ingoingFee}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>${{printData.list[2].data.ingoingFees.ingoingFee}}</th>
            </template>
          </tr>
          <tr>
            <th>ongoing fee</th>
            <!-- 1 -->
            <th>${{data.ongoingFees.ongoingFee}}</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th>${{printData.list[1].data.ongoingFees.ongoingFee}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>${{printData.list[2].data.ongoingFees.ongoingFee}}</th>
            </template>
          </tr>
          <tr>
            <th>outgoing fee applies</th>
            <!-- 1 -->
            <th v-if="data.outgoingFees.hasOutgoingFees">Yes</th>
            <th v-if="!data.outgoingFees.hasOutgoingFees">No</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="printData.list[1].data.outgoingFees.hasOutgoingFees">Yes</th>
              <th v-if="!printData.list[1].data.outgoingFees.hasOutgoingFees">No</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="printData.list[2].data.outgoingFees.hasOutgoingFees">Yes</th>
              <th v-if="!printData.list[2].data.outgoingFees.hasOutgoingFees">No</th>
            </template>
          </tr>
          <tr>
            <th>ingoing fee, resale value, or higher of the 2</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFeeType === 'Ingoing Fee')">ingoing</th>
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFeeType === 'Resale Value')">resale</th>
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFeeType === 'Higher of the Two')">higher</th>
            <th v-if="!data.outgoingFees.hasOutgoingFees">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFeeType === 'Ingoing Fee')">ingoing</th>
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFeeType === 'Resale Value')">resale</th>
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFeeType === 'Higher of the Two')">higher</th>
              <th v-if="!printData.list[1].data.outgoingFees.hasOutgoingFees">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFeeType === 'Ingoing Fee')">ingoing</th>
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFeeType === 'Resale Value')">resale</th>
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFeeType === 'Higher of the Two')">higher</th>
              <th v-if="!printData.list[2].data.outgoingFees.hasOutgoingFees">n / a</th>
            </template>
          </tr>
          <tr>
            <th>maximum percentage outgoing fee</th>
            <!-- 1 -->
            <th v-if="data.outgoingFees.hasOutgoingFees">{{data.outgoingFees.maximumOutgoingFee}}%</th>
            <th v-if="!data.outgoingFees.hasOutgoingFees">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="printData.list[1].data.outgoingFees.hasOutgoingFees">{{printData.list[1].data.outgoingFees.maximumOutgoingFee}}%</th>
              <th v-if="!printData.list[1].data.outgoingFees.hasOutgoingFees">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="printData.list[2].data.outgoingFees.hasOutgoingFees">{{printData.list[2].data.outgoingFees.maximumOutgoingFee}}%</th>
              <th v-if="!printData.list[2].data.outgoingFees.hasOutgoingFees">n / a</th>
            </template>
          </tr>
          <tr>
            <th>minimum percentage outgoing fee</th>
            <!-- 1 -->
            <th v-if="data.outgoingFees.hasOutgoingFees">{{data.outgoingFees.minimumOutgoingFee}}%</th>
            <th v-if="!data.outgoingFees.hasOutgoingFees">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="printData.list[1].data.outgoingFees.hasOutgoingFees">{{printData.list[1].data.outgoingFees.minimumOutgoingFee}}%</th>
              <th v-if="!printData.list[1].data.outgoingFees.hasOutgoingFees">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="printData.list[2].data.outgoingFees.hasOutgoingFees">{{printData.list[2].data.outgoingFees.minimumOutgoingFee}}%</th>
              <th v-if="!printData.list[2].data.outgoingFees.hasOutgoingFees">n / a</th>
            </template>
          </tr>
          <!-- 1 -->
          <tr>
            <th>outgoing fee annual percentage fee in period 1</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 1)">{{data.outgoingFees.outgoingFee.list[0].rate}}%</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 1)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 1)">{{printData.list[1].data.outgoingFees.outgoingFee.list[0].rate}}%</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 1)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 1)">{{printData.list[2].data.outgoingFees.outgoingFee.list[0].rate}}%</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 1)">n / a</th>
            </template>
          </tr>
          <tr>
            <th>length of period 1 in years</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 1)">{{data.outgoingFees.outgoingFee.list[0].period}}</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 1)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 1)">{{printData.list[1].data.outgoingFees.outgoingFee.list[0].period}}</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 1)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 1)">{{printData.list[2].data.outgoingFees.outgoingFee.list[0].period}}</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 1)">n / a</th>
            </template>
          </tr>
          <!-- 2 -->
          <tr>
            <th>outgoing fee annual percentage fee in period 2</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 2)">{{data.outgoingFees.outgoingFee.list[1].rate}}%</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 2)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 2)">{{printData.list[1].data.outgoingFees.outgoingFee.list[1].rate}}%</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 2)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 2)">{{printData.list[2].data.outgoingFees.outgoingFee.list[1].rate}}%</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 2)">n / a</th>
            </template>
          </tr>
          <tr>
            <th>length of period 2 in years</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 2)">{{data.outgoingFees.outgoingFee.list[1].period}}</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 2)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 2)">{{printData.list[1].data.outgoingFees.outgoingFee.list[1].period}}</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 2)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 2)">{{printData.list[2].data.outgoingFees.outgoingFee.list[1].period}}</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 2)">n / a</th>
            </template>
          </tr>
          <!-- 3 -->
          <tr>
            <th>outgoing fee annual percentage fee in period 3</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 3)">{{data.outgoingFees.outgoingFee.list[2].rate}}%</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 3)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 3)">{{printData.list[1].data.outgoingFees.outgoingFee.list[2].rate}}%</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 3)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 3)">{{printData.list[2].data.outgoingFees.outgoingFee.list[2].rate}}%</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 3)">n / a</th>
            </template>
          </tr>
          <tr>
            <th>length of period 3 in years</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 3)">{{data.outgoingFees.outgoingFee.list[2].period}}</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 3)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 3)">{{printData.list[1].data.outgoingFees.outgoingFee.list[2].period}}</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 3)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 3)">{{printData.list[2].data.outgoingFees.outgoingFee.list[2].period}}</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 3)">n / a</th>
            </template>
          </tr>
          <!-- 4 -->
          <tr>
            <th>outgoing fee annual percentage fee in period 4</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 4)">{{data.outgoingFees.outgoingFee.list[3].rate}}%</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 4)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 4)">{{printData.list[1].data.outgoingFees.outgoingFee.list[3].rate}}%</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 4)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 4)">{{printData.list[2].data.outgoingFees.outgoingFee.list[3].rate}}%</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 4)">n / a</th>
            </template>
          </tr>
          <tr>
            <th>length of period 4 in years</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 4)">{{data.outgoingFees.outgoingFee.list[3].period}}</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 4)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 4)">{{printData.list[1].data.outgoingFees.outgoingFee.list[3].period}}</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 4)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 4)">{{printData.list[2].data.outgoingFees.outgoingFee.list[3].period}}</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 4)">n / a</th>
            </template>
          </tr>
          <!-- 5 -->
          <tr>
            <th>outgoing fee annual percentage fee in period 5</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 5)">{{data.outgoingFees.outgoingFee.list[4].rate}}%</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 5)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 5)">{{printData.list[1].data.outgoingFees.outgoingFee.list[4].rate}}%</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 5)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 5)">{{printData.list[2].data.outgoingFees.outgoingFee.list[4].rate}}%</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 5)">n / a</th>
            </template>
          </tr>
          <tr>
            <th>length of period 5 in years</th>
            <!-- 1 -->
            <th v-if="(data.outgoingFees.hasOutgoingFees) && (data.outgoingFees.outgoingFee.length >= 5)">{{data.outgoingFees.outgoingFee.list[4].period}}</th>
            <th v-if="(!data.outgoingFees.hasOutgoingFees) || (data.outgoingFees.outgoingFee.length < 5)">n / a</th>
            <!-- 2 -->
            <template v-if="printData.length > 1">
              <th v-if="(printData.list[1].data.outgoingFees.hasOutgoingFees) && (printData.list[1].data.outgoingFees.outgoingFee.length >= 5)">{{printData.list[1].data.outgoingFees.outgoingFee.list[4].period}}</th>
              <th v-if="(!printData.list[1].data.outgoingFees.hasOutgoingFees) || (printData.list[1].data.outgoingFees.outgoingFee.length < 5)">n / a</th>
            </template>
            <template v-if="printData.length > 2">
              <th v-if="(printData.list[2].data.outgoingFees.hasOutgoingFees) && (printData.list[2].data.outgoingFees.outgoingFee.length >= 5)">{{printData.list[2].data.outgoingFees.outgoingFee.list[4].period}}</th>
              <th v-if="(!printData.list[2].data.outgoingFees.hasOutgoingFees) || (printData.list[2].data.outgoingFees.outgoingFee.length < 5)">n / a</th>
            </template>
          </tr>
          <!-- capital gains / loss -->
          <tr>
            <th>resident's share of capital gains</th>
            <th>{{data.capitalGainLoss.capitalGain}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.capitalGainLoss.capitalGain}}%</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.capitalGainLoss.capitalGain}}%</th>
            </template>
          </tr>
          <tr>
            <th>resident's share of capital loss</th>
            <th>{{data.capitalGainLoss.capitalLoss}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.capitalGainLoss.capitalLoss}}%</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.capitalGainLoss.capitalLoss}}%</th>
            </template>
          </tr>
          <!-- additional outgoing fee -->
          <tr>
            <th>outgoing delay</th>
            <th>{{data.additionalOutgoingFees.outgoingDelay}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.additionalOutgoingFees.outgoingDelay}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.additionalOutgoingFees.outgoingDelay}}</th>
            </template>
          </tr>
          <tr>
            <th>refurbish fee</th>
            <th>{{data.additionalOutgoingFees.outgoingRefurbishFee}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.additionalOutgoingFees.outgoingRefurbishFee}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.additionalOutgoingFees.outgoingRefurbishFee}}</th>
            </template>
          </tr>
          <tr>
            <th>operator commission</th>
            <th>{{data.additionalOutgoingFees.operatorCommission}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.additionalOutgoingFees.operatorCommission}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.additionalOutgoingFees.operatorCommission}}</th>
            </template>
          </tr>
          <tr>
            <th>capital maintenance fee</th>
            <th>{{data.additionalOutgoingFees.capitalMaintenanceFee}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.additionalOutgoingFees.capitalMaintenanceFee}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.additionalOutgoingFees.capitalMaintenanceFee}}</th>
            </template>
          </tr>
          <tr>
            <th>capital maintenance period</th>
            <th>{{data.additionalOutgoingFees.capitalMaintenancePeriod}}</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.additionalOutgoingFees.capitalMaintenancePeriod}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.additionalOutgoingFees.capitalMaintenancePeriod}}</th>
            </template>
          </tr>
          <!-- assumptions -->
          <tr>
            <th><label class="label">Assumptions</label></th>
            <th></th>
            <template v-if="printData.length > 1">
              <th></th>
            </template>
            <template v-if="printData.length > 2">
              <th></th>
            </template>
          </tr>
          <tr>
            <th>interest rate</th>
            <th>{{data.assumptions.interestRate}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.assumptions.interestRate}}</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.assumptions.interestRate}}</th>
            </template>
          </tr>
          <tr>
            <th>inflation rate</th>
            <th>{{data.assumptions.inflationRate}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.assumptions.inflationRate}}%</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.assumptions.inflationRate}}%</th>
            </template>
          </tr>
          <tr>
            <th>risk free interest rate</th>
            <th>{{data.assumptions.riskFreeInterestRate}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.assumptions.riskFreeInterestRate}}%</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.assumptions.riskFreeInterestRate}}%</th>
            </template>
          </tr>
          <tr>
            <th>real estate volatility</th>
            <th>{{data.assumptions.realEstateVolatility}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.assumptions.realEstateVolatility}}%</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.assumptions.realEstateVolatility}}%</th>
            </template>
          </tr>
          <tr>
            <th>rental yield</th>
            <th>{{data.assumptions.rentalYield}}%</th>
            <template v-if="printData.length > 1">
              <th>{{printData.list[1].data.assumptions.rentalYield}}%</th>
            </template>
            <template v-if="printData.length > 2">
              <th>{{printData.list[2].data.assumptions.rentalYield}}%</th>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import Start from '../modules/stages/Start'
import PropertyDetails from '../modules/stages/PropertyDetails'
import Assumptions from '../modules/stages/Assumptions'
import BasicInformation from '../modules/stages/BasicInformation'
import IngoingFees from '../modules/stages/IngoingFees'
import OngoingFees from '../modules/stages/OngoingFees'
import OutgoingFees from '../modules/stages/OutgoingFees'
import CapitalGainLoss from '../modules/stages/CapitalGainLoss'
import ResultA from '../modules/stages/ResultA'
import ResultB from '../modules/stages/ResultB'
import AdditionalOutgoingFees from '../modules/stages/AdditionalOutgoingFees'
import Review from '../modules/stages/Review.vue'

export default {
  inject: ['$validator'],
  components: {
    AdditionalOutgoingFees,
    ResultA,
    ResultB,
    CapitalGainLoss,
    OutgoingFees,
    OngoingFees,
    IngoingFees,
    BasicInformation,
    Start,
    PropertyDetails,
    Assumptions,
    Review
  },
  data() {
    return {
      agree: false,
      printData: {
        length: 0,
        list: []
      },
      cleanRun: true,
      printing: false,
      loading: false,
      responsePayload: {
        sorted_response: [
          {
            term: null,
            rent: null,
            name: '2 year term'
          },
          {
            term: null,
            rent: null,
            name: '5 year term'
          },
          {
            term: null,
            rent: null,
            name: '10 year term'
          },
          {
            term: null,
            rent: null,
            name: '20 year term'
          },
          {
            term: null,
            rent: null,
            name: 'expected term'
          }
        ],
        response: {
          expected_healthy_lifespan: null,
          two_year_rent_per_month: null,
          five_year_rent_per_month: null,
          ten_year_rent_per_month: null,
          twenty_year_rent_per_month: null,
          expected_healthy_lifespan_year_rent_per_month: null,
          error: null
        }
      },
      state: 'start',
      status: {
        start: 'dirty',
        propertyDetails: 'pristine',
        assumptions: 'pristine',
        basicInformation: 'pristine',
        ingoingFees: 'pristine',
        ongoingFees: 'pristine',
        outgoingFees: 'pristine',
        capitalGainLoss: 'pristine',
        additionalOutgoingFees: 'pristine',
        resultA: 'pristine',
        resultB: 'pristine',
        review: 'pristine'
      },
      data: {
        propertyDetails: {
          villageName: '',
          unitNumber: ''
        },
        assumptions: {
          hasAssumptions: false,
          interestRate: '4.0',
          inflationRate: '2.2',
          riskFreeInterestRate: '4.3',
          realEstateVolatility: '20',
          rentalYield: '3.92'
        },
        basicInformation: {
          isCouple: false,
          age: null,
          gender: null,
          partnerAge: null,
          partnerGender: null
        },
        ingoingFees: {
          ingoingFee: null
        },
        ongoingFees: {
          ongoingFee: null,
          ongoingFeePeriod: 'Monthly'
        },
        outgoingFees: {
          hasOutgoingFees: false,
          outgoingFeeType: 'Ingoing Fee',
          useCalculatedMax: true,
          maximumOutgoingFee: '0',
          minimumOutgoingFee: '0',
          outgoingFee: {
            length: 1,
            list: [
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              }
            ]
          }
        },
        capitalGainLoss: {
          hasCapitalGain: false,
          hasCapitalLoss: false,
          capitalGain: '0',
          capitalLoss: '0'
        },
        additionalOutgoingFees: {
          outgoingDelayOption: 'No',
          outgoingRefurbishFeeOption: 'No',
          operatorCommissionOption: 'No',
          capitalMaintenanceFeeOption: 'No',
          outgoingDelay: '0',
          outgoingRefurbishFee: '0',
          operatorCommission: '0',
          capitalMaintenanceFee: '0',
          capitalMaintenancePeriod: '0'
        }
      }
    }
  },
  methods: {
    next: function() {
      if (this.state === 'start') {
        this.fromStart()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toAssumptions()
            this.status.start = 'valid'
          }
        })
      } else if (this.state === 'property-details') {
        this.fromPropertyDetails()
        this.$nextTick(() => {
          this.toIngoingFees()
          this.status.propertyDetails = 'valid'
        })
      } else if (this.state === 'assumptions') {
        this.fromAssumptions()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toBasicInformation()
            this.status.assumptions = 'valid'
          }
        })
      } else if (this.state === 'basic-information') {
        this.fromBasicInformation()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toPropertyDetails()
            this.status.basicInformation = 'valid'
          }
        })
      } else if (this.state === 'ingoing-fees') {
        this.fromIngoingFees()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toOngoingFees()
            this.status.ingoingFees = 'valid'
          }
        })
      } else if (this.state === 'ongoing-fees') {
        this.fromOngoingFees()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toCapitalGainLoss()
            this.status.ongoingFees = 'valid'
          }
        })
      } else if (this.state === 'outgoing-fees') {
        this.fromOutgoingFees()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toAdditionalOutgoingFees()
            this.status.outgoingFees = 'valid'
          }
        })
      } else if (this.state === 'capital-gain-loss') {
        this.fromCapitalGainLoss()
        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.toOutgoingFees()
            this.status.capitalGainLoss = 'valid'
          }
        })
      } else if (this.state === 'additional-outgoing-fees') {
        this.fromAdditionalOutgoingFees()
        this.$validator.validateAll().then(() => {
          this.$nextTick(() => {
            if (!this.errors.any()) {
              this.toResultA()
              this.status.additionalOutgoingFees = 'valid'
            }
          })
        })
      } else if (this.state === 'resultA') {
        this.fromResultA()
        this.$nextTick(() => {
          this.toResultB()
          this.status.resultA = 'valid'
        })
      } else if (this.state === 'resultB') {
        this.fromResultB()
        this.$nextTick(() => {
          this.toReview()
          this.status.resultB = 'valid'
        })
      }
    },
    previous: function() {
      if (this.state === 'property-details') {
        this.toBasicInformation()
      } else if (this.state === 'assumptions') {
        this.toStart()
      } else if (this.state === 'basic-information') {
        this.toAssumptions()
      } else if (this.state === 'ingoing-fees') {
        this.toPropertyDetails()
      } else if (this.state === 'ongoing-fees') {
        this.toIngoingFees()
      } else if (this.state === 'outgoing-fees') {
        this.toCapitalGainLoss()
      } else if (this.state === 'capital-gain-loss') {
        this.toOngoingFees()
      } else if (this.state === 'additional-outgoing-fees') {
        this.toOutgoingFees()
      } else if (this.state === 'resultA') {
        this.toAdditionalOutgoingFees()
      } else if (this.state === 'resultB') {
        this.toResultA()
      } else if (this.state === 'review') {
        this.toResultB()
      }
    },
    // From
    fromStart: function() {
      this.errors.clear()
    },
    fromPropertyDetails: function() {
      this.errors.clear()
    },
    fromAssumptions: function() {
      this.errors.clear()
      if (this.data.assumptions.hasAssumptions) {
        this.$validator.validate('interest-rate', this.data.assumptions.interestRate)
        this.$validator.validate('inflation-rate', this.data.assumptions.inflationRate)
        this.$validator.validate('risk-free-interest-rate', this.data.assumptions.riskFreeInterestRate)
        this.$validator.validate('real-estate-volatility', this.data.assumptions.realEstateVolatility)
        this.$validator.validate('rental-yield', this.data.assumptions.rentalYield)
      } else {
        this.data.assumptions.interestRate = '4.0'
        this.data.assumptions.inflationRate = '2.2'
        this.data.assumptions.riskFreeInterestRate = '3.92'
        this.data.assumptions.realEstateVolatility = '20'
        this.data.assumptions.rentalYield = '4.3'
      }
    },
    fromBasicInformation: function() {
      this.errors.clear()
      this.$validator.validate('age', this.data.basicInformation.age)
      this.$validator.validate('gender', this.data.basicInformation.gender)
      if (this.data.basicInformation.isCouple === true) {
        this.$validator.validate('partner-age', this.data.basicInformation.partnerAge)
        this.$validator.validate('partner-gender', this.data.basicInformation.partnerGender)
      }
    },
    fromIngoingFees: function() {
      this.errors.clear()
      this.$validator.validate('ingoing-fee', this.data.ingoingFees.ingoingFee)
    },
    fromOngoingFees: function() {
      this.errors.clear()
      this.$validator.validate('ongoing-fee', this.data.ongoingFees.ongoingFee)
    },
    fromOutgoingFees: function() {
      this.errors.clear()
      if (this.data.outgoingFees.hasOutgoingFees) {
        if (this.data.outgoingFees.useCalculatedMax === false) {
          this.$validator.validate('maximum-outgoing-fee', this.data.outgoingFees.maximumOutgoingFee)
        }
        // this.$validator.validate('minimum-outgoing-fee', this.data.outgoingFees.minimumOutgoingFee)
        for (let i = 0; i < this.data.outgoingFees.outgoingFee.length; i++) {
          this.$validator.validate('outgoing-fee-rate-' + i.toString(), this.data.outgoingFees.outgoingFee.list[i].rate)
          this.$validator.validate(
            'outgoing-fee-from-year-' + i.toString(),
            this.data.outgoingFees.outgoingFee.list[i].fromYear
          )
          this.$validator.validate(
            'outgoing-fee-to-year-' + i.toString(),
            this.data.outgoingFees.outgoingFee.list[i].toYear
          )
        }
      }
    },
    fromCapitalGainLoss: function() {
      this.errors.clear()
      if (this.data.capitalGainLoss.hasCapitalGain) {
        this.$validator.validate('capital-gain', this.data.capitalGainLoss.capitalGain)
      } else {
        this.data.capitalGainLoss.capitalGain = '0'
      }
      if (this.data.capitalGainLoss.hasCapitalLoss) {
        this.$validator.validate('capital-loss', this.data.capitalGainLoss.capitalLoss)
      } else {
        this.data.capitalGainLoss.capitalLoss = '0'
      }
    },
    fromAdditionalOutgoingFees: function() {
      this.errors.clear()
      if (this.data.additionalOutgoingFees.outgoingDelayOption !== 'No') {
        this.$validator.validate('outgoing-delay', this.data.additionalOutgoingFees.outgoingDelay)
      }
      if (this.data.additionalOutgoingFees.outgoingRefurbishFeeOption !== 'No') {
        this.$validator.validate('outgoing-refurbish-fee', this.data.additionalOutgoingFees.outgoingRefurbishFee)
      }
      if (this.data.additionalOutgoingFees.operatorCommissionOption !== 'No') {
        this.$validator.validate('operator-commission', this.data.additionalOutgoingFees.operatorCommission)
      }
      if (this.data.additionalOutgoingFees.capitalMaintenanceOption !== 'No') {
        this.$validator.validate('capital-maintenance-fee', this.data.additionalOutgoingFees.capitalMaintenanceFee)
        this.$validator.validate(
          'capital-maintenance-period',
          this.data.additionalOutgoingFees.capitalMaintenancePeriod
        )
      }
    },
    fromResultA: function() {
      this.errors.clear()
    },
    fromResultB: function() {
      this.errors.clear()
    },
    // To
    toStart: function() {
      this.status.start = 'dirty'
      this.state = 'start'
    },
    toPropertyDetails: function() {
      this.status.propertyDetails = 'dirty'
      this.state = 'property-details'
    },
    toAssumptions: function() {
      this.status.assumptions = 'dirty'
      this.state = 'assumptions'
    },
    toBasicInformation: function() {
      this.status.basicInformation = 'dirty'
      this.state = 'basic-information'
    },
    toIngoingFees: function() {
      this.status.ingoingFees = 'dirty'
      this.state = 'ingoing-fees'
    },
    toOngoingFees: function() {
      this.status.ongoingFees = 'dirty'
      this.state = 'ongoing-fees'
    },
    toOutgoingFees: function() {
      this.status.outgoingFees = 'dirty'
      this.state = 'outgoing-fees'
    },
    toCapitalGainLoss: function() {
      this.status.capitalGainLoss = 'dirty'
      this.state = 'capital-gain-loss'
    },
    toAdditionalOutgoingFees: function() {
      this.status.additionalOutgoingFees = 'dirty'
      this.state = 'additional-outgoing-fees'
    },
    toResultA: function() {
      this.post()
      this.status.resultA = 'dirty'
      this.state = 'resultA'
    },
    toResultB: function() {
      this.status.resultB = 'dirty'
      this.state = 'resultB'
    },
    toReview: function() {
      this.status.review = 'dirty'
      this.state = 'review'
    },
    // Jump
    jumpStart: function() {
      if (this.cleanRun === true) {
        this.toStart()
      }
    },
    jumpPropertyDetails: function() {
      if (this.status.propertyDetails !== 'pristine') {
        this.toPropertyDetails()
      }
    },
    jumpAssumptions: function() {
      if (this.status.assumptions !== 'pristine' && this.cleanRun === true) {
        this.toAssumptions()
      }
    },
    jumpBasicInformation: function() {
      if (this.status.basicInformation !== 'pristine' && this.cleanRun === true) {
        this.toBasicInformation()
      }
    },
    jumpIngoingFees: function() {
      if (this.status.ingoingFees !== 'pristine') {
        this.toIngoingFees()
      }
    },
    jumpOngoingFees: function() {
      if (this.status.ongoingFees !== 'pristine') {
        this.toOngoingFees()
      }
    },
    jumpOutgoingFees: function() {
      if (this.status.outgoingFees !== 'pristine') {
        this.toOutgoingFees()
      }
    },
    jumpCapitalGainLoss: function() {
      if (this.status.capitalGainLoss !== 'pristine') {
        this.toCapitalGainLoss()
      }
    },
    jumpAdditionalOutgoingFees: function() {
      if (this.status.additionalOutgoingFees !== 'pristine') {
        this.toAdditionalOutgoingFees()
      }
    },
    jumpResult: function() {
      if (this.status.resultA !== 'pristine') {
        this.toResultA()
      }
    },
    post: function() {
      if (this.data.additionalOutgoingFees.outgoingDelayOption !== 'False') {
        if (this.data.additionalOutgoingFees.outgoingDelayOption === 'Default') {
          this.data.additionalOutgoingFees.outgoingDelay = '6'
        }
      }
      if (this.data.additionalOutgoingFees.outgoingRefurbishFeeOption === 'False') {
        if (this.data.additionalOutgoingFees.outgoingRefurbishFeeOption === 'Default') {
          this.data.additionalOutgoingFees.outgoingRefurbishFee = '15000'
        }
      }
      if (this.data.additionalOutgoingFees.operatorCommissionOption === 'False') {
        if (this.data.additionalOutgoingFees.operatorCommissionOption === 'Default') {
          this.data.additionalOutgoingFees.operatorCommission = '3'
        }
      }
      if (this.data.additionalOutgoingFees.capitalMaintenanceFeeOption === 'False') {
        if (this.data.additionalOutgoingFees.capitalMaintenanceFeeOption === 'Default') {
          this.data.additionalOutgoingFees.capitalMaintenanceFee = '0.2'
          this.data.additionalOutgoingFees.capitalMaintenancePeriod = '10'
        }
      }
      this.loading = true
      this.axios
        .post(`/api/0.2/basic`, this.data)
        .then(response => {
          this.responsePayload.response = JSON.parse(JSON.stringify(response.data))
          this.responsePayload.sorted_response[0].term = this.responsePayload.response.expected_healthy_lifespan
          this.responsePayload.sorted_response[0].rent = this.responsePayload.response.expected_healthy_lifespan_year_rent_per_month
          this.responsePayload.sorted_response[0].name = 'expected term'
          this.responsePayload.sorted_response[1].term = 2
          this.responsePayload.sorted_response[1].rent = this.responsePayload.response.two_year_rent_per_month
          this.responsePayload.sorted_response[1].name = '2 year term'
          this.responsePayload.sorted_response[2].term = 5
          this.responsePayload.sorted_response[2].rent = this.responsePayload.response.five_year_rent_per_month
          this.responsePayload.sorted_response[2].name = '5 year term'
          this.responsePayload.sorted_response[3].term = 10
          this.responsePayload.sorted_response[3].rent = this.responsePayload.response.ten_year_rent_per_month
          this.responsePayload.sorted_response[3].name = '10 year term'
          this.responsePayload.sorted_response[4].term = 20
          this.responsePayload.sorted_response[4].rent = this.responsePayload.response.twenty_year_rent_per_month
          this.responsePayload.sorted_response[4].name = '20 year term'
          this.printData.list.unshift({
            data: JSON.parse(JSON.stringify(this.data)),
            response: JSON.parse(JSON.stringify(this.responsePayload.response))
          })
          this.printData.length += 1
          console.log(JSON.stringify(this.printData))
          this.loading = false
        })
        .catch(e => {
          // eslint-disable-next-line
          console.log(e)
        })
    },
    printResults() {
      this.printing = true
      this.$nextTick(() => {
        window.print()
        this.printing = false
      })
    },
    restartCalculator() {
      this.cleanRun = true
      this.agree = false
      this.printData = { length: 0, list: [] }
      this.data = {
        propertyDetails: {
          villageName: '',
          unitNumber: ''
        },
        assumptions: {
          hasAssumptions: false,
          interestRate: '4.0',
          inflationRate: '2.2',
          riskFreeInterestRate: '3.92',
          realEstateVolatility: '20',
          rentalYield: '4.3'
        },
        basicInformation: {
          isCouple: false,
          age: null,
          gender: null,
          partnerAge: null,
          partnerGender: null
        },
        ingoingFees: {
          ingoingFee: null
        },
        ongoingFees: {
          ongoingFee: null,
          ongoingFeePeriod: 'Monthly'
        },
        outgoingFees: {
          hasOutgoingFees: false,
          outgoingFeeType: 'Ingoing Fee',
          maximumOutgoingFee: '0',
          minimumOutgoingFee: '0',
          outgoingFee: {
            length: 1,
            list: [
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              },
              {
                rate: '0',
                fromYear: '0',
                toYear: '0'
              }
            ]
          }
        },
        capitalGainLoss: {
          hasCapitalGain: false,
          hasCapitalLoss: false,
          capitalGain: '0',
          capitalLoss: '0'
        },
        additionalOutgoingFees: {
          outgoingDelayOption: 'No',
          outgoingRefurbishFeeOption: 'No',
          operatorCommissionOption: 'No',
          capitalMaintenanceFeeOption: 'No',
          outgoingDelay: '0',
          outgoingRefurbishFee: '0',
          operatorCommission: '0',
          capitalMaintenanceFee: '0',
          capitalMaintenancePeriod: '0'
        }
      }
      this.status = {
        start: 'dirty',
        propertyDetails: 'pristine',
        assumptions: 'pristine',
        basicInformation: 'pristine',
        ingoingFees: 'pristine',
        ongoingFees: 'pristine',
        outgoingFees: 'pristine',
        capitalGainLoss: 'pristine',
        additionalOutgoingFees: 'pristine',
        resultA: 'pristine',
        resultB: 'pristine',
        review: 'pristine'
      }
      this.jumpStart()
    },
    enterAnotherContract() {
      this.cleanRun = false
      this.data.propertyDetails = {
        villageName: '',
        unitNumber: ''
      }
      this.data.ingoingFees = {
        ingoingFee: null
      }
      this.data.ongoingFees = {
        ongoingFee: null,
        ongoingFeePeriod: 'Monthly'
      }
      this.data.outgoingFees = {
        hasOutgoingFees: false,
        outgoingFeeType: 'Ingoing Fee',
        maximumOutgoingFee: '0',
        minimumOutgoingFee: '0',
        outgoingFee: {
          length: 1,
          list: [
            {
              rate: '0',
              fromYear: '0',
              toYear: '0'
            },
            {
              rate: '0',
              fromYear: '0',
              toYear: '0'
            },
            {
              rate: '0',
              fromYear: '0',
              toYear: '0'
            },
            {
              rate: '0',
              fromYear: '0',
              toYear: '0'
            },
            {
              rate: '0',
              fromYear: '0',
              toYear: '0'
            }
          ]
        }
      }
      this.data.capitalGainLoss = {
        hasCapitalGain: false,
        hasCapitalLoss: false,
        capitalGain: '0',
        capitalLoss: '0'
      }
      this.data.additionalOutgoingFees = {
        outgoingDelayOption: 'No',
        outgoingRefurbishFeeOption: 'No',
        operatorCommissionOption: 'No',
        capitalMaintenanceFeeOption: 'No',
        outgoingDelay: '0',
        outgoingRefurbishFee: '0',
        operatorCommission: '0',
        capitalMaintenanceFee: '0',
        capitalMaintenancePeriod: '0'
      }
      this.jumpPropertyDetails()
    }
  }
}
</script>

<style scoped>
.stripes {
  background: linear-gradient(150deg, #a6192e 15%, #76232f 70%, #76232f 94%);
  transform: skewY(-10deg);
  height: 60%;
  width: 120%;
  overflow: hidden;
  transform-origin: 0;
  position: absolute;
}

header {
  position: relative;
  display: block;
  box-sizing: border-box;
}

.spaced-column {
  justify-content: space-between;
  flex-direction: column;
  display: flex;
  height: auto;
}

.full-width {
  width: 100%;
}

.nav-buttons {
  padding-top: 2rem;
  padding-bottom: 0.5rem;
}

.full-height {
  display: flex;
  height: 100%;
}

.class-transition {
  transition: 0.5s;
}

.menu-button {
  justify-content: left;
  border: none;
}

.menu-tag {
  justify-content: left;
  border: none;
}

.center-logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Calculator.vue